import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollPositionService {

  constructor() { }

  private scrollPositionSubject = new BehaviorSubject<number>(0);
  private currentPageSubject = new BehaviorSubject<number>(1);  // Default to page 1

  public scrollPosition$ = this.scrollPositionSubject.asObservable();
  public currentPage$ = this.currentPageSubject.asObservable();  // Observable for current page

  // Set and get scroll position
  public setScrollPosition(position: number): void {
    this.scrollPositionSubject.next(position);
  }

  public getScrollPosition(): Observable<number> {
    return this.scrollPosition$;
  }

  // Set and get current page
  public setCurrentPage(page: number): void {
    this.currentPageSubject.next(page);
  }
  
  public getCurrentPage(): Observable<number> {
    return this.currentPage$;
  }
  
}
